import Link from "next/link";
import AmdLogo from "public/pricing/amd.webp";
import { scrollToElement } from "@/utils/scrollToElement";

export const ISV_DESKTOP_DATA = [
  {
    image: AmdLogo,
    processor: "AMD RYZEN 3900X",
    memory: "64GB",
    baseclock_boost: "3.8 GHZ | 4.6 GHZ",
    disk: "2 X 2TB",
    gpu: "NVIDIA RTX 2080Ti",
    price: "₹36,540",
  },
  {
    image: AmdLogo,
    processor: "AMD Ryzen™ 9 7950X3D",
    memory: "128GB",
    baseclock_boost: "4.2 GHZ | 5.7 GHZ",
    disk: "2 X 4TB",
    gpu: "NVIDIA T1000-8GB",
    price: "₹49,590",
  },
  {
    image: AmdLogo,
    processor: "AMD TR PRO 7965WX 24C",
    memory: "256GB",
    baseclock_boost: "4.2 GHZ | 5.3 GHZ",
    disk: "2 X 256GB | 2 X 4TB",
    gpu: "2 X NVIDIA RTX™ A4000 16GB GDDR6",
    price: "₹1,01,790",
  },
  {
    image: AmdLogo,
    processor: "AMD TR PRO 7975WX 32C",
    memory: "256GB",
    baseclock_boost: "4 GHZ | 5.3 GHZ",
    disk: "2 X 512GB | 2 X 4TB",
    gpu: "2 X NVIDIA RTX™ A4000 16GB GDDR6",
    price: "₹1,12,230",
  },
  {
    image: AmdLogo,
    processor: "AMD TR PRO 7985WX 64C",
    memory: "512GB",
    baseclock_boost: "3.2 GHZ | 5.1 GHZ",
    disk: "2 X 1TB | 4 X 4TB",
    gpu: "2 X NVIDIA RTX™ A5000 32GB GDDR6",
    price: "₹2,29,680",
  },
  {
    image: AmdLogo,
    processor: "AMD TR PRO 7995WX 96C",
    memory: "1024GB",
    baseclock_boost: "2.5 GHZ | 5.1 GHZ",
    disk: "2 X 1TB | 4 X 4TB",
    gpu: "1 X NVIDIA RTX™ A6000 48GB GDDR6",
    price: "₹3,13,200",
  },
  {
    image: AmdLogo,
    processor: "AMD TR PRO 7995WX 96C",
    memory: "1024GB",
    baseclock_boost: "2.5 GHZ | 5.1 GHZ",
    disk: "2 X 1TB | 4 X 4TB",
    gpu: "2 X NVIDIA RTX™ A6000 48GB GDDR6",
    price: "₹3,65,400",
  },
];

export const TableFooter = {
  note: "(Windows Licensing needs to be purchased Seperately) ",
  text: (
    <>
      We offer a range of ISV desktops tailored for your business needs. Pricing may
      fluctuate based on configuration, duration, and region. For more details, please
      contact{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        target="_blank"
        style={{ textDecoration: "underline", color: "#1E87F0", fontWeight: 700 }}
      >
        our sales team
      </Link>
      .
    </>
  ),
};
